import Configuration from './Configuration';

export interface HSL {
    h: number;
    s: number;
    l: number;
}

export default class ChartConfiguration {
    public fillColor: string;
    public strokeColor: string;
    public highlightFill: string;
    public highlightStroke: string;

    public backgroundColor: string;
    public borderColor: string;
    public pointBackgroundColor: string;
    public pointBorderColor: string;
    public pointHoverBackgroundColor: string;
    public pointHoverBorderColor: string;

    static fromConfigurations(from: Configuration[], index?: number, length?: number) {
        let conf = {};
        from.forEach(f => {
            conf[f.key] = f.value;
        });
        return new ChartConfiguration(conf, index, length);
    }
    // minDiff: number, maxDiff: number,
    protected getRandomColor(whiteness: number, index: number, length?: number) {
        // let deltaDiff = maxDiff - minDiff;
        // let minpoint = whiteness +  minDiff;
        let h, s, l;
        if (isNaN(length)) {

            h = (index % 16) * 25;
            index = Math.floor(index / 16);
            s =  30 + (index % 5) * 10 ;
            l =  30 + (index % 5) * 10 ;
        } else {
            h = (328 / length) * (index);
            s = 30;
            l = 30;
        }
        return {h, s, l} as HSL;   
    }
    protected getColorString(hsl: HSL) {
        return `hsl(${Math.floor(hsl.h)}, ${Math.floor(hsl.s)}%, ${Math.floor(hsl.l)}%)`;
    }

    protected multiply(hsl: HSL, by: number) {
        return {
            h: hsl.h * by,
            s: hsl.s * by,
            l: hsl.l * by
        } as HSL;
    }
      
    protected add(hsl: HSL, by: number) {
        return {
            h: hsl.h + by,
            s: hsl.s + by,
            l: hsl.l + by
        } as HSL;
    }    
    
    protected divide(hsl: HSL, by: number) {
        return {
            h: Math.floor(hsl.h / by),
            s: Math.floor(hsl.s / by),
            l: Math.floor(hsl.l / by)
        } as HSL;
    }

    protected subtract(hsl: HSL, by: number) {
        return {
            h: hsl.h / by,
            s: hsl.s / by,
            l: hsl.l / by
        } as HSL;
    }

    constructor(_input?: any, index?: number, length?: number) {
        let input: any = _input || {};
        if (isNaN(index)) {
            index = Math.floor(Math.random() * 500);
        }

        let baseBrightness = 200;
        // let minDiff = -100;
        // let maxDiff = -50;
        let brighterMultiple = 1.618;
        let dimmerMultiple = 0.89;

        var baseColor = this.getRandomColor(baseBrightness, index, length);
            
        this.fillColor = input.fillColor || this.getColorString(this.multiply(baseColor, brighterMultiple));
        this.strokeColor = input.strokeColor || 'grey';
        this.highlightFill = input.highlightFill || this.getColorString(baseColor);
        this.highlightStroke = input.highlightStroke || 'white';
        
        this.backgroundColor = input.backgroundColor || this.getColorString(baseColor);
        this.borderColor =  input.borderColor || this.getColorString(baseColor);
        this.pointBackgroundColor = input.pointBackgroundColor || 
            this.getColorString(this.multiply(baseColor, brighterMultiple));
        this.pointBorderColor = input.pointBorderColor ||
            this.getColorString(baseColor);
        this.pointHoverBackgroundColor = input.pointHoverBackgroundColor ||
            this.getColorString(this.multiply(baseColor, dimmerMultiple));
        this.pointHoverBorderColor = input.pointHoverBorderColor ||
            this.getColorString(this.multiply(baseColor, dimmerMultiple));
        
    }

    toConfig(): Configuration[] {
        let config = {
            fillColor: this.fillColor,
            strokeColor: this.strokeColor,
            highlightFill: this.highlightFill,
            highlightStroke: this.highlightStroke,

            backgroundColor: this.backgroundColor,
            borderColor: this.borderColor,
            pointBackgroundColor: this.pointBackgroundColor,
            pointBorderColor: this.pointBorderColor,
            pointHoverBackgroundColor: this.pointHoverBackgroundColor,
            pointHoverBorderColor: this.pointHoverBorderColor,
        };
        let ret: Configuration[];
        Object.keys(config).forEach(key => {
            ret.push(new Configuration({ key, value: config[key] }));
        });
        return ret;
    }
}



// WEBPACK FOOTER //
// ./src/stores/application/classes/ChartConfiguration.ts